import React, { useRef, useState } from "react";
import styles from "../../pages/Login/index.module.css";
import myStyles from "./index.module.css";
import { toast } from "react-toastify";
import { changePassword } from "../../../api/auth";
import { useNavigate } from "react-router-dom";

const EnterNewPassword = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [pass, setPass] = useState({
    new: "",
    confirm: "",
  });

  const [showPassword, setShowPassword] = useState({
    new: false,
    confirm: false,
  });

  const onPassChange = (e) => {
    setPass({ ...pass, [e.target.name]: e.target.value });
  };

  const debounce = () => {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(onSetPassword, 300);
    };
  };

  const onSetPassword = () => {
    if (!loader) {
      let err = 0;

      if (pass.new === "") {
        err++;
        toast.error("New Password is required!");
      } else if (pass.new.length < 8) {
        err++;
        toast.error("New Password should have atleast 8 characters!");
      }

      if (pass.confirm === "") {
        err++;
        toast.error("Confirm Password is required!");
      } else if (pass.confirm.length < 8) {
        err++;
        toast.error("Confirm Password should have atleast 8 characters!");
      } else if (pass.confirm !== pass.new) {
        err++;
        toast.error("New Password and confirm password do not match!");
      }

      if (err == 0) {
        setLoader(true);
        changePassword(pass.new, pass.confirm).then((res) => {
          setLoader(false);
          if (res.status == "success") {
            toast.success(res.message);
            sessionStorage.removeItem("secret");
            sessionStorage.removeItem("username");
            sessionStorage.clear();
            navigate("/");
          } else {
            toast.error(res.message);
          }
        });
      }
    }
  };
  return (
    <div className={styles["right"]}>
      <div className={styles["form"]} style={{ width: "72.4%" }}>
        <div className={styles["text"]}>
          <div className={styles["main"]}>Enter New Password</div>
          <div className={styles["sub"]}>
            Use this form to change your password. Once changed, your new
            password will take effect the next time you log in
          </div>
        </div>
        <div className={styles["inputs"]}>
          <div className={styles["input_box"]}>
            <div className={styles["label"]}>New Password</div>
            <div className={styles["input"] + " " + myStyles["input"]}>
              <input
                type={showPassword.new ? "text" : "password"}
                value={pass.new}
                name="new"
                onChange={onPassChange}
              />
              {showPassword.new ? (
                <i
                  className="bi bi-eye"
                  onClick={() =>
                    setShowPassword({
                      ...showPassword,
                      new: false,
                    })
                  }
                ></i>
              ) : (
                <i
                  className="bi bi-eye-slash"
                  onClick={() =>
                    setShowPassword({
                      ...showPassword,
                      new: true,
                    })
                  }
                ></i>
              )}
            </div>
          </div>
          <div className={styles["input_box"]}>
            <div className={styles["label"]}>Confirm Password</div>
            <div className={styles["input"] + " " + myStyles["input"]}>
              <input
                type={showPassword.confirm ? "text" : "password"}
                value={pass.confirm}
                name="confirm"
                onChange={onPassChange}
              />
              {showPassword.confirm ? (
                <i
                  className="bi bi-eye"
                  onClick={() =>
                    setShowPassword({
                      ...showPassword,
                      confirm: false,
                    })
                  }
                ></i>
              ) : (
                <i
                  className="bi bi-eye-slash"
                  onClick={() =>
                    setShowPassword({
                      ...showPassword,
                      confirm: true,
                    })
                  }
                ></i>
              )}
            </div>
          </div>
        </div>
        <div className={styles["submission"]}>
          <div className={styles["main_cta"]}>
            <div className={styles["button"]} onClick={debounce()}>
              Set New Password
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterNewPassword;
